:root {
  --simplero-side-panel-width: 500px;
  --simplero-side-panel-min-width: 300px;
  --simplero-side-panel-max-width: 95vw;
  --simplero-side-panel-top-offset: var(--top-bar-height, 50px);
}

#side_panel {
  --simplero-effective-side-panel-width: clamp(var(--simplero-side-panel-min-width),
      var(--simplero-side-panel-width),
      var(--simplero-side-panel-max-width));

  position: fixed;
  top: var(--simplero-side-panel-top-offset);
  right: calc(var(--simplero-effective-side-panel-width) * -1);
  bottom: 0px;
  transition: right 0.25s;
  margin: 0;
  /* page header is 999, checklist bar is 1002, settings dropdown menu is 9999 — we want this above checklist */
  z-index: 1003;
  width: var(--simplero-effective-side-panel-width);
  border-left: 1px solid var(--tw-color-border-base);
  overflow-y: auto;
  background: var(--tw-color-bg-alt);
  color: var(--tw-color-fg-base);

  &.no-transition {
    transition: none;
  }

  /* Editing a whole document next to its settings (send-email steps). Dragging still resizes it,
     saved under the content's own data-side-panel-width-key. */
  &.side_panel--wide {
    --simplero-side-panel-width: max(66vw, 960px);
    --simplero-side-panel-max-width: 100vw;
  }

  &.open {
    box-shadow: 0px 12px 16px -4px rgba(15, 23, 42, 0.08),
      0px 4px 6px -2px rgba(15, 23, 42, 0.03);
    right: 0;
  }

  .side_panel__header {
    position: sticky;
    top: 0;
    padding-top: 20px;
    z-index: 101;
    background: var(--tw-color-bg-alt);
  }

  .side_panel__body {
    padding: 20px 0;
  }

  .side_panel__form {
    padding: 16px 20px;
  }

  .currency-field--with-tax {
    .col-md-6 {
      width: 70%;
    }
  }

  .side_panel__loader {
    position: fixed;
    top: 0;
    right: 0;
    width: var(--simplero-effective-side-panel-width);
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 100;
    /*
       80% of the panel's bg-alt surface: neutral-0 here, neutral-900 in the .dark block below.
       Same channel variables + fallbacks as the Tailwind neutral palette (tailwind.config.base.js);
       admin never defines them, so the fallback values apply.
    */
    background: rgba(var(--color-neutral-0-rgb, 255, 255, 255), 0.8);
    font-size: 17px;
    transition: all 0.2s ease-in-out;
    display: none;

    i {
      font-size: 64px;
      display: block;
      margin-bottom: 30px;
    }
  }

  .side_panel__resize-handle {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0px;
    width: 2px;
    cursor: ew-resize;

    &:hover {
      width: 8px;
    }
  }

  /*
     If personalizations button exist on a sidebar,
     most likely is on a form in on the right side of the screen,
     so better to its dropdown/content growing to the left of the screen.
  */
  .btn-personalizations {
    .dropdown-menu {
      right: 0;
      left: auto;
    }
  }
}

/*
   Bootstrap form controls carry no dark-mode styling of their own (white background,
   light gray border). The side panel is always rendered on the dark `bg-alt` surface,
   so recolor the controls that legacy (Bootstrap) forms render inside it.
*/
.dark #side_panel {
  .side_panel__loader {
    background: rgba(var(--color-neutral-900-rgb, 15, 23, 42), 0.8);
  }

  .form-control {
    background-color: var(--tw-color-bg-alt);
    border-color: var(--tw-color-border-base);
    color: var(--tw-color-fg-base);

    &::placeholder {
      color: var(--tw-color-fg-faint);
    }
  }

  .btn-personalizations {
    .dropdown-toggle {
      background-color: var(--tw-color-bg-base);
      border-color: var(--tw-color-border-base);
    }

    .dropdown-menu {
      background-color: var(--tw-color-bg-alt);
      border-color: var(--tw-color-border-base);

      > li > a {
        color: var(--tw-color-fg-base);

        &:hover,
        &:focus {
          background: var(--tw-color-bg-base);
          color: var(--tw-color-fg-base);
        }
      }
    }
  }
}

.side-panel-resizing * {
  pointer-events: none !important;
  user-select: none;

  .side_panel__resize-handle {
    pointer-events: auto !important;
  }
}

/* make side panel wider on smaller screens, otherwise many items break or behave horrible */
@media only screen and (max-width: 1200px) {
  :root {
    --simplero-side-panel-width: 40%;
    --simplero-side-panel-min-width: 30%;
  }
}

/*
   Phones: the panel takes the whole screen. Overrides the effective width rather than
   --simplero-side-panel-width, so a width saved on desktop (set inline by side_panel_controller)
   is ignored here and applies again once the screen is wide enough.
*/
@media only screen and (max-width: 767px) {
  #side_panel {
    --simplero-effective-side-panel-width: 100%;
    border-left: 0;

    .side_panel__resize-handle {
      display: none;
    }
  }
}

body:has(.side_panel.open) #support-widget,
body:has(.side_panel.open) .simplero-help-desk-widget,
body:has(.side_panel.open) .simplero-frustration-widget {
  display: none;
}
